// state
const state = () => ({
  idCenario: null,
  ncm: null,
  modalListaCenarios: false,
  modalInvertCenarios: false,
  modalImpressao: false,
});

// getters
const getters = {
  getNcmCenario: (state) => {
    return state.ncm
  },
  getIdCenario: (state) => {
    return state.idCenario
  },
  getModalListaCenarios: (state) => {
    return state.modalListaCenarios;
  },
  getModalInvertCenarios: (state) => {
    return state.modalInvertCenarios
  },
  getModalImpressao: (state) => {
    return state.modalImpressao
  },
};

// mutations
const mutations = {
  SET_MODAL_LISTA_CENARIOS (state, modalListaCenarios) {
    state.modalListaCenarios = modalListaCenarios
  },
  SET_NCM_CENARIO (state, ncm) {
    state.ncm = ncm
  },
  SET_ID_CENARIO (state, idCenario) {
    state.idCenario = idCenario
  },
  SET_INVERT_CENARIOS (state, modalInvertCenarios) {
    state.modalInvertCenarios = modalInvertCenarios
  },
  SET_MODAL_IMPRESSAO (state, modalImpressao) {
    state.modalImpressao = modalImpressao
  },
}

// actions
const actions = {
  setModalListaCenarios ({ commit }, { id, modal, ncm }) {
    commit('SET_NCM_CENARIO', ncm)
    commit('SET_ID_CENARIO', id)
    commit('SET_MODAL_LISTA_CENARIOS', modal)
  },
  setModalInvertCenarios ({ commit }, modalInvertCenarios) {
    commit('SET_INVERT_CENARIOS', modalInvertCenarios)
  },
  setModalImpressao ({ commit }, modalImpressao) {
    commit('SET_MODAL_IMPRESSAO', modalImpressao)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
